module.exports = __webpack_public_path__ + "img/fukuoka.64d754b2.png";